<script setup>
import {
    computed,
} from 'vue';
import AppIcon from '../../atoms/app/AppIcon';
import AppLink from '../../atoms/app/AppLink';
import SkeletonBox from '../../atoms/skeleton/SkeletonBox';
import TextHeadline from '../../atoms/text/TextHeadline';

const props = defineProps({
    conversation: {
        default: null,
        type: Object,
    },
    to: {
        type: Object,
    },
});

const isLoading = computed(() => !props.conversation);

</script>

<template>
    <div
        class="c-appMessageItem k-o-media k-o-media--s u-partial-hover-parent"
    >
        <div class="k-o-media__figure">
            <AppIcon
                :name="conversation && conversation.replied ? 'arrow-back' : 'dot'"
                :class="{ 'c-appMessageItem__status--inactive':
                    isLoading || conversation.read || conversation.replied }"
                :data-qa="`${conversation && conversation.replied ? 'replied' : 'dot'} icon`"
                fixed-width
                class="c-appMessageItem__status"
            />
        </div>
        <div class="k-o-media__body">
            <div class="k-c-excerpt">
                <TextHeadline
                    :level="3"
                    variant="base-700"
                    class="k-c-excerpt__headline u-partial-hover-child"
                    data-qa="headline"
                >
                    <SkeletonBox
                        v-if="isLoading"
                        :min-width="50"
                        :max-width="70"
                        data-qa="skeleton box"
                    />
                    <AppLink
                        v-else
                        :to="{
                            name: 'page-conversation-detail',
                            params: { id: conversation.id },
                        }"
                        neutral
                        class="c-appMessageItem__link"
                        data-qa="conversation subject link"
                        data-gtm-element="DB: Messages"
                        data-gtm-element-detail="Open Detail"
                    >
                        <slot
                            name="headline"
                        />
                    </AppLink>
                </TextHeadline>
                <div
                    class="k-c-excerpt__snippet c-appMessageItem__snippet"
                    data-qa="snippet"
                >
                    <SkeletonBox
                        v-if="isLoading"
                        data-qa="skeleton box"
                    />
                    <slot v-else/>
                </div>
                <div class="k-c-excerpt__metaEnd c-appMessageItem__metaEnd">
                    <SkeletonBox
                        v-if="isLoading"
                        data-qa="skeleton box"
                    />
                    <slot
                        v-else
                        name="meta-end"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '../../../assets/scss/utilities/anchor-block-overlay';

// 1. Increase specificity to override styles from Global-Styles (this component should be refactored in the future
//    so that this is no longer necessary)
.c-appMessageItem {
    $root: &;

    position: relative;

    &__status {
        color: var(--k-green-600);

        &--inactive {
            color: var(--k-gray-300);
        }
    }

    &__link {
        @include anchor-block-overlay;
    }

    .k-c-excerpt { // 1
        #{$root}__snippet,
        #{$root}__metaEnd {
            color: var(--k-gray-600);
        }
    }
}
</style>
